module.exports = __webpack_public_path__ + "assets/img/f99c5fa222a84290f3dd4f238abdc74b.png";